<template>
  <div>
    <CRow class="mt-5">
      <CCol sm="9">
        <h4 class>
          {{ $t('settings.security.component.removeAccount') }}
        </h4>
        <div class="border-line"></div>
      </CCol>
    </CRow>
    <CRow class="mb-5 mt-4">
      <CCol>
        <CButton type="button" color="primary" class="px-5 py-2" @click="openDeletionPopup" :disabled="userButtonDeleteAccount">
          {{ $t('settings.security.component.button.delete') }}
        </CButton>
      </CCol>
    </CRow>
    <transition name="fade" v-if="confirmDeleteUserPopUp">
      <div class="dataTable__popUp popUp" style="margin-top: -90px; margin-left: 15px">
        <div v-if="!confirmationForm" class="popUp__body shadow-sm">
          <div class="confirmationDelete">
            <div class="confirmationDelete__header">
              <p class="co nfirmationDelete__title font-weight-semi-bold mb-3">
                {{ $t('settings.security.component.phoneNumber.removeAccount.popup.title') }}
                <br />
                {{ $t('settings.security.component.phoneNumber.removeAccount.popup.questions') }}
              </p>
            </div>
            <div class="confirmationDelete__footer mt-4">
              <div class="confirmationDelete__actions">
                <CButton color="primary" class="py-2 px-5 mr-3 text-uppercase" @click="closeConfirmDeleteUserPopUp">
                  {{ $t('settings.security.component.phoneNumber.removeAccount.popup.no') }}
                </CButton>
                <CButton color="error" class="py-2 px-5 text-uppercase" @click="openConfirmDeleteUserPopUp">
                  {{ $t('settings.security.component.phoneNumber.removeAccount.popup.yes') }}
                </CButton>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="popUp__body shadow-sm">
          <div class="confirmationDelete">
            <div class="confirmationDelete__header">
              <p class="confirmationDelete__title font-weight-semi-bold mb-1">
                {{ $t('settings.security.component.phoneNumber.removeAccount.popup.title2') }}
              </p>
            </div>
            <div class="confirmationDelete__body mb-4">
              <input type="text" class="form-control" v-model="confirmDeleteAccountText" />
            </div>
            <div class="confirmationDelete__footer">
              <CRow>
                <CCol>
                  <CButton color="primary" class="py-2 px-4 text-uppercase" @click="closeConfirmDeleteUserPopUp" t>{{
                    $t('settings.security.component.phoneNumber.removeAccount.popup.cancel')
                  }}</CButton>
                </CCol>
                <CCol>
                  <CButton color="error" class="py-2 px-4 text-uppercase" :disabled="!isConfirmTextValid || loading" @click="disableUser">{{
                    $t('settings.security.component.phoneNumber.removeAccount.popup.confirm')
                  }}</CButton>
                </CCol>
              </CRow>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import services from '@/services.js'

export default {
  data() {
    return {
      userButtonDeleteAccount: false,
      confirmationForm: false,
      confirmDeleteUserPopUp: false,
      loading: false,
      confirmDeleteAccountText: '',
    }
  },
  computed: {
    isConfirmTextValid() {
      return this.confirmDeleteAccountText === 'DELETE'
    },
  },
  methods: {
    openDeletionPopup() {
      this.confirmDeleteUserPopUp = true
      this.userButtonDeleteAccount = true
    },
    openConfirmDeleteUserPopUp() {
      this.confirmationForm = true
    },
    closeConfirmDeleteUserPopUp() {
      this.confirmDeleteUserPopUp = false
      this.userButtonDeleteAccount = false
      this.confirmationForm = false
      this.loading = false
      this.confirmDeleteAccountText = ''
    },
    disableUser() {
      let userId = this.$store.state.auth.user.id
      this.loading = true
      services
        .disableUser(userId)
        .then((response) => {
          this.$emit('showMessage', {
            status: 'success',
            text: this.$t('settings.security.messages.disable-user-success'),
          })

          setTimeout(() => {
            this.$store.dispatch('auth/logout')
          }, 3000)
        })
        .catch((error) => {
          this.closeConfirmDeleteUserPopUp()
          this.$emit('showMessage', {
            status: 'danger',
            text: error.response.data.message,
          })
        })
    },
  },
}
</script>
